import { RemoveRedEye } from "@mui/icons-material";
import { Button, styled } from "@mui/material";
import { Curriculum } from "api/types";

const PREFIX = "PreviewActivity";

const classes = {
	previewBtn: `${PREFIX}-previewBtn`,
	img: `${PREFIX}-img`,
};

const Root = styled("div")(({ theme }) => ({
	[`& .${classes.previewBtn}`]: {
		borderRadius: 50,
		padding: theme.spacing(1),
		paddingLeft: theme.spacing(1.5),
		paddingRight: theme.spacing(1.5),
	},

	[`& .${classes.img}`]: {
		minWidth: "50%",
		minHeight: "50%",
	},
}));

export interface PreviewCurriculumProps {
	curriculum: Curriculum;
}

export const PreviewCurriculum = ({
	curriculum,
}: PreviewCurriculumProps): JSX.Element => {
	const baseURL = "http://rdf.australiancurriculum.edu.au/elements/2018/05/";

	const getCurriculumUrl = (curriculumId: string): string => {
		return baseURL + curriculumId;
	};

	return (
		<Root>
			<Button
				variant="contained"
				color="primary"
				className={classes.previewBtn}
				onClick={() => window.open(getCurriculumUrl(curriculum.id), "_blank")}
			>
				<RemoveRedEye /> Preview
			</Button>
		</Root>
	);
};
